<template>
  <div class="d-flex justify-content-center">

    <nav v-if="last > 1">
      <ul class="pagination pagination-sm">

        <li class="page-item" @click="changePage(1)" :class="{'disabled':current <= 1}" v-if="last > 5">
          <button type="button" class="page-link" tabindex="-1"
                  :disabled="current <= 1">
            اولین
          </button>
        </li>

        <li class="page-item" @click="changePage(current - 1)" :class="{'disabled':current <= 1}">
          <button type="button" class="page-link" tabindex="-1"
                  :disabled="current <= 1">قبلی
          </button>
        </li>

        <li class="page-item" v-for="x in range" :key="x" :class="{'active': x === current }">
          <button type="button" class="page-link" @click="changePage(x)">{{ x }}</button>
        </li>

        <li class="page-item" @click="changePage(current + 1)" :class="{'disabled': last <= current}">
          <button type="button" class="page-link" :disabled="last <= current">بعدی</button>
        </li>

        <li class="page-item" @click="changePage(last)" :class="{'disabled': last <= current}" v-if="last > 5">
          <button type="button" class="page-link" :disabled="last <= current">آخرین</button>
        </li>
      </ul>
    </nav>

  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    data: {default: {}},
    change: {type: Function}
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.data.last_page)
        this.$emit('change', page);
    }
  },
  computed: {
    current() {
      return this.data && this.data.current_page ? this.data.current_page : 0;
    },
    last() {
      return this.data && this.data.last_page ? this.data.last_page : 0;
    },
    range() {
      if (this.data && this.data.last_page) {

        if (this.data.last_page > 5) {
          let start = 1;
          start = this.current - 2;
          if (start < 1) {
            const t = Math.abs(start);
            start += t + 1;
          }
          let end = start + 4;
          if (end >= this.data.last_page) {
            const t = end - this.data.last_page;
            end -= t;
            start -= t;
          }

          const arr = [];
          for (let i = start; i <= end; i++)
            arr.push(i);
          return arr;
        } else {
          return this.data.last_page
        }
      }

      return 0;
    }
  }
}
</script>

<style scoped>

</style>